import React from "react";

import { Spin } from "antd";

import LocationToolbar from "../components/multi-location/LocationToolbar";
import SubscriptionCategoryUsage from "../subscription/components/SubscriptionCategoryUsage";
import SummaryCard from "../subscription/components/SummaryCard";

import { getSubscriptionTierUsage } from "../utils";

import "./PostpayDashboard.css";

const ALL_LOCATIONS_KEY = "all";

const sumPostpayCategoryUsage = (categories = []) => (
  categories.reduce((totals, category) => {
    (category.tiers || []).forEach((tier) => {
      const { used, remaining } = getSubscriptionTierUsage(tier, { billingMode: "postpay" });
      totals.consumed += used;
      totals.adjustment += remaining;
    });
    return totals;
  }, { consumed: 0, adjustment: 0 })
);

const formatCreditTotal = (value) => (
  Number(value).toLocaleString(undefined, { maximumFractionDigits: 2 })
);

export default function PostpayDashboard({
  categoryUsage = [],
  locations,
  selectedLocationKey = ALL_LOCATIONS_KEY,
  onSelectLocation,
  periodLabel,
  onPeriodChange,
  loading = false,
}) {
  const { consumed, adjustment } = sumPostpayCategoryUsage(categoryUsage);

  return (
    <div className="PostpayUsage">
      <LocationToolbar
        locations={locations}
        selectedLocationKey={selectedLocationKey}
        onSelectLocation={onSelectLocation}
        periodLabel={periodLabel}
        onPeriodChange={onPeriodChange}
      />

      {loading ? (
        <div className="PostpayUsage__Loading">
          <Spin size="large" />
        </div>
      ) : (
        <>
          <section className="PostpayUsage__Summary">
            <SummaryCard
              title="Total consumption"
              value={formatCreditTotal(consumed)}
              valueTone="secondary"
              detail="Across all categories"
              detailMuted
            />
            <SummaryCard
              title="Adjustment tests"
              value={formatCreditTotal(adjustment)}
              valueTone="secondary"
              detail="Across all categories"
              detailMuted
            />
          </section>
          <SubscriptionCategoryUsage
            title="Category Test Usage"
            categories={categoryUsage}
            billingMode="postpay"
            showUsageMeter={false}
            countLabel="adjustment"
            usedLabel="consumed"
          />
        </>
      )}
    </div>
  );
}
